import { Star } from 'lucide-react';
import { SectionHeader } from '@/components/charts/SectionHeader';
import { MotionCard } from '@/components/motion/MotionCard';
import { RatingTrends } from './RatingTrends';

export function RatingsPage() {
  return (
    <div className="space-y-8">
      <SectionHeader
        title={
          <span className="flex items-center gap-2">
            <Star className="h-5 w-5 text-amber-500" />
            Ratings — current vs previous, per outlet per source
          </span>
        }
        description="Google, Swiggy, and Zomato side-by-side. Drops surface here first; severe ones feed Active Fires + the weekly checklist."
      />

      <MotionCard delay={0.02}>
        <RatingTrends />
      </MotionCard>
    </div>
  );
}
